import { render, staticRenderFns } from "./EmpresasServicosAdmin.vue?vue&type=template&id=5e5a6110&scoped=true"
import script from "./EmpresasServicosAdmin.vue?vue&type=script&lang=js"
export * from "./EmpresasServicosAdmin.vue?vue&type=script&lang=js"
import style0 from "./EmpresasServicosAdmin.vue?vue&type=style&index=0&id=5e5a6110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a6110",
  null
  
)

export default component.exports